export enum AwsActionTypes {
  UPLOAD_TO_S3_REQUEST = "@@AWS/UPLOAD_TO_S3_REQUEST",
  UPLOAD_TO_S3_SUCCESS = "@@AWS/UPLOAD_TO_S3_SUCCESS",
  UPLOAD_TO_S3_FAILURE = "@@AWS/UPLOAD_TO_S3_FAILURE",
  UPLOAD_TO_S3_CANCEL = "@@AWS/UPLOAD_TO_S3_CANCEL",
}
